var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationBing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.52C11.59 10.52 11.25 10.18 11.25 9.77V6.44C11.25 6.03 11.59 5.69 12 5.69C12.41 5.69 12.75 6.03 12.75 6.44V9.77C12.75 10.19 12.41 10.52 12 10.52Z",
    fill: "#6E7987"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0201 20.35C9.44011 20.35 6.87011 19.94 4.42011 19.12C3.51011 18.82 2.82011 18.17 2.52011 17.35C2.22011 16.53 2.32011 15.59 2.81011 14.77L4.08011 12.65C4.36011 12.18 4.61011 11.3 4.61011 10.75V8.65C4.61011 4.56 7.93011 1.24 12.0201 1.24C16.1101 1.24 19.4301 4.56 19.4301 8.65V10.75C19.4301 11.29 19.6801 12.18 19.9601 12.65L21.2301 14.77C21.7001 15.55 21.7801 16.48 21.4701 17.33C21.1601 18.18 20.4801 18.83 19.6201 19.12C17.1701 19.95 14.6001 20.35 12.0201 20.35ZM12.0201 2.75C8.76011 2.75 6.11011 5.4 6.11011 8.66V10.76C6.11011 11.57 5.79011 12.74 5.37011 13.43L4.10011 15.56C3.84011 15.99 3.78011 16.45 3.93011 16.85C4.08011 17.25 4.42011 17.55 4.90011 17.71C9.50011 19.24 14.5601 19.24 19.1601 17.71C19.5901 17.57 19.9201 17.25 20.0701 16.83C20.2301 16.41 20.1801 15.95 19.9501 15.56L18.6801 13.44C18.2601 12.75 17.9401 11.58 17.9401 10.77V8.67C17.9301 5.4 15.2801 2.75 12.0201 2.75Z",
    fill: "#6E7987"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 22.9C10.9299 22.9 9.87992 22.46 9.11992 21.7C8.35992 20.94 7.91992 19.89 7.91992 18.82H9.41992C9.41992 19.5 9.69992 20.16 10.1799 20.64C10.6599 21.12 11.3199 21.4 11.9999 21.4C13.4199 21.4 14.5799 20.24 14.5799 18.82H16.0799C16.0799 21.07 14.2499 22.9 11.9999 22.9Z",
    fill: "#6E7987"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBing);
export default __webpack_public_path__ + "static/media/notification-bing.d8e7e7088b031dbcbc4ea7a525284170.svg";
export { ForwardRef as ReactComponent };